import { Object, String, Union, Literal, Static, Optional } from '@sinclair/typebox';

export const AwardSendOneTimePasswordBody = Object({
  orderId: String(),
});

export const AwardVerifyOneTimePasswordBody = Object({
  orderId: String(),
  code: String(),
});

export enum OneTimePasswordMethod {
  Email = 'email',
  Sms = 'sms',
}

export enum SendOneTimePasswordStatus {
  Sent = 'sent',
  Successful = 'Successful',
}

export const AwardSendOneTimePasswordResponse = Object({
  status: Union([Literal(SendOneTimePasswordStatus.Sent), Literal(SendOneTimePasswordStatus.Successful)]),
  method: Optional(Union([Literal(OneTimePasswordMethod.Email), Literal(OneTimePasswordMethod.Sms)])),
  receiver: Optional(String()),
});

export type AwardSendOneTimePasswordResponse = Static<typeof AwardSendOneTimePasswordResponse>;

export enum OneTimePasswordErrorType {
  Expired = 'Expired',
  InvalidCode = 'InvalidCode',
}

export const AwardVerifyOneTimePasswordError = Object({
  bookingErrorType: Union([Literal(OneTimePasswordErrorType.Expired), Literal(OneTimePasswordErrorType.InvalidCode)]),
});

export type AwardVerifyOneTimePasswordError = Static<typeof AwardVerifyOneTimePasswordError>;
